<template>
  <div class="impact-statement" redesign>
    <!-- Header -->
    <NomineeProgressBar v-if="employeeCode"
      stepName="Impact Statement"
      :stepNumber=3
      :numberOfSteps=5
    />
    <NomineeProgressBar v-else
      stepName="Impact Statement"
      :stepNumber=1
      :numberOfSteps=3
    />

    <div class="form-container impact-statement-form">
      <LoadSpinner v-if="loading" :color="`#${organizationDetails.darkBrandColor}`" />
      <template v-if="!loading">
        <SurveyResponseComponent
          :surveyResponse="surveyResponse"
          :cleanSurvey="false"
          :buttonText="$gettext('Next')"
          @survey-done="handleSubmit"
          :context="{ nominatedBy: user.nominatedByFullName }"
          :darkText="true"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import { LoadSpinner } from '@/components'
import NomineeProgressBar from '@/components/stepper/NomineeProgressBar'
import SurveyResponseComponent from '@/components/SurveyResponse'

import NomineesApi from '@/services/nominees'
import SurveyResponse from '@/services/surveyresponses'
import StipendRequest from '@/services/stipendRequests'

export default {
  name: 'NomineeOnboardingImpactStatement',
  components: {
    LoadSpinner,
    NomineeProgressBar,
    SurveyResponseComponent,
  },
  data() {
    return {
      loading: true,
      employeeCode: null,
      surveyName: 'Nominee Impact Statement',
      surveyResponse: null,
    }
  },
  created() {
    this.employeeCode = this.$route.params.code
  },
  async mounted() {
    const stipendRequest = await NomineesApi.createOrGetStipendRequest({ program_month: 1 })
    await this.$store.dispatch('updateCurrentRequest', stipendRequest)

    // We found the current request, update our model
    if(stipendRequest.impactStatement)
      this.surveyResponse = await SurveyResponse.api.retrieve(stipendRequest.impactStatement)

    // If the survey response doesn't exist, then create one
    if(!this.surveyResponse) {
      this.surveyResponse = await SurveyResponse.getOrCreate(this.user, this.surveyName)

      // Update our current request w/ the survey reference & save the stipend request
      stipendRequest['impactStatement'] = this.surveyResponse.id
      this.$store.dispatch('updateCurrentRequest', stipendRequest)
      await NomineesApi.saveStipendRequest(stipendRequest)
    }

    // Start editing ping
    this.$store.dispatch('startEditingStipendRequestPing', stipendRequest)

    this.loading = false
  },
  unmounted() {
    this.$store.dispatch('stopEditingStipendRequestPing')
  },
  beforeRouteLeave(to, from,  next) {
    this.$store.dispatch('stopEditingStipendRequestPing')
    next()
  },
  methods: {
    handleSubmit() {
      StipendRequest.api.trackUpdate(this.currentRequest, StipendRequest.options.IMPACT_STATEMENT_UPDATED)
      this.$router.push({ name: 'NomineeOnboardingPersonalDetails', params: { code: this.employeeCode }, })
    },
  },
  computed: {
    ...mapState(['user', 'organizationDetails', 'organizationCssVars', 'currentRequest']),
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixins/responsive';

.impact-statement {
  display: flex;
  flex-direction: column;

  .impact-statement-form {
    @extend .constrain-tablet-and-up;

    @media (min-width: 1140px) {
      max-width: 1076px !important;
    }
  }
}
</style>
